import { BraidProvider } from 'braid-design-system';
import theme from 'braid-design-system/themes/seekBusiness';
import { ToastProvider } from '../contexts/ToastProvider';
import { LoggerProvider } from '../contexts/LoggerProvider';
import { ErrorBoundary } from '../components/ErrorBoundary';
import AppRoutes from '../routes';
import { AuthProvider } from '../contexts/AuthProvider';
import { UserPermissionAndMenuProvider } from '../contexts/UserPermissionAndMenuProvider';
import { CashierProvider } from '../contexts/CashierProvider';
import { FinancialDateProvider } from '../contexts/FinancialDateProvider';
import { WebSocketProvider } from '../contexts/WebSocketProvider';
import { config } from '../config/app.config';
import { LocalDateTimeProvider } from '../contexts/LocalDateTimeProvider';
import { PageHeadingProvider } from '../contexts/PageHeadingProvider';

// Main App component with providers
export const App = () => {
  return (
    <BraidProvider theme={theme}>
      <LoggerProvider>
        <ToastProvider>
          <ErrorBoundary>
            <AuthProvider>
              <UserPermissionAndMenuProvider>
                <CashierProvider>
                  <FinancialDateProvider>
                    <WebSocketProvider wsUrl={config.wsUrl}>
                      <LocalDateTimeProvider>
                        <PageHeadingProvider>
                          <AppRoutes />
                        </PageHeadingProvider>
                      </LocalDateTimeProvider>
                    </WebSocketProvider>
                  </FinancialDateProvider>
                </CashierProvider>
              </UserPermissionAndMenuProvider>
            </AuthProvider>
          </ErrorBoundary>
        </ToastProvider>
      </LoggerProvider>
    </BraidProvider>
  );
};
